/* eslint-disable max-len */
import axiosClient from './axiosClient'

const categoryApi = {
  getCategoryList: () => {
    const url = '/get-category'
    return axiosClient.get(url)
  },

  addCategory: (data) => {
    const url = '/add-category'
    return axiosClient.post(url, data)
  },

  editCategory: (data) => {
    const url = '/edit-category'
    return axiosClient.patch(url, data)
  },

  deleteCategory: (id) => {
    const url = `/delete-category?id=${id}`
    return axiosClient.delete(url)
  },
}

export default categoryApi
